import { Location } from "@angular/common";
import { Component, DoCheck, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { AnalyticEvent } from "app/lib/analytic-event";
import { ApiService } from "app/lib/api.service";
import { LogService } from "app/lib/log.service";
import { SeriesService } from "app/lib/series.service";
import { UserService } from "app/lib/user.service";
import { Reads, voice } from "app/models/course";
import { User } from "app/models/user";

@Component({
    selector: "app-org-series-contents",
    templateUrl: "./org-series-contents.component.html",
    styleUrls: ["./org-series-contents.component.scss"],
    standalone: false
})
export class OrgSeriesContentsComponent implements OnInit, DoCheck {
  title = "";
  user: User;
  lang: string = "en";
  videoSeriesList: any = [];
  voiceSeriesList: any = [];
  organizationOwnContentTitle: string = "";
  isVideoSeriesloaded: boolean = false;
  isStorySeriesloaded: boolean = false;
  storySeriesList: voice[] = [];
  isBqSeriesloaded: boolean = false;
  bqSeriesList: voice[] = [];
  
  readableSeriesList: Reads[] = [];
  isReadableSeriesloaded: boolean = false;
  showBreadcrumbs: boolean = true;
  constructor(
    private userService: UserService,
    private location: Location,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private seriesService: SeriesService,
    private api: ApiService,
    private log: LogService,
    private translate: TranslateService
  ) {
    this.user = this.userService.getUser();
    this.lang = this.translate.currentLang;
    this.showBreadcrumbs = this.user?.userType === 'user' ? true : false;
      this.organizationOwnContentTitle =
      this.user?.primaryOrganization?.settings[
        "organizationOwnContentTitle" + this.lang.replace(/^\w/, (c) => c.toUpperCase())
      ] || "";
  }

  ngOnInit() {
    this.getVideoSeries();
    this.getStorySerliesList();
    this.getBQSerliesList();
    this.getReadableSeries();
  }
  ngDoCheck() {
    this.lang = this.translate.currentLang;
  }
  goBack() {
        this.location.back();
    }
  getVideoSeries() {
    this.isVideoSeriesloaded = false;
    this.seriesService
      .getOrgCustiomVideoSeriesList(this.user.primaryOrganization.id)
      .subscribe((data: any) => {
        if (data && data.length > 0) {
          this.videoSeriesList = data;
        }
        this.isVideoSeriesloaded = true;
      });
  }

  getStorySerliesList() {
    this.isStorySeriesloaded = false;
    let payLoad = {
      CourseType: "organization",
    };
    this.api.get("series/stories", payLoad).subscribe(
      (response: any) => {
        this.isStorySeriesloaded = true;
        this.storySeriesList = voice.initializeArray(
          response || [],
          "stories",
        );
      },
      (error) => {
        this.log.event(
          AnalyticEvent.internalPagesEvents.customOrgStorySeriesFetchError,
        );
      },
    );
  }

  getBQSerliesList() {
    this.isBqSeriesloaded = false;
    let payLoad = {
      CourseType: "organization",
    };
    this.api.get("series/burningquestions", payLoad).subscribe(
      (response: any) => {
        this.isBqSeriesloaded = true;
        this.bqSeriesList = voice.initializeArray(
          response || [],
          "burningQuestion",
        );
      },
      (error) => {
        this.log.event(
          AnalyticEvent.internalPagesEvents
            .customOrgBurningQuestionSeriesFetchError,
        );
      },
    );
  }

  getReadableSeries() {
    this.isReadableSeriesloaded = false;
    let payLoad = {
      CourseType: "organization",
    };
    this.seriesService
      .getOrgCustiomReadableSeriesList(this.user.primaryOrganization.id,
        payLoad,)
      .subscribe((data: any) => {
        if (data) {
          this.readableSeriesList = data || [];
        }
        this.isReadableSeriesloaded = true;
      });
  }
  
  viewAllSeriesContent(type: string) {
    this.router.navigate(["/app/series/org-series-contents/" + type]);
  }
  goToVideoSeries(series) {
    this.router.navigate(["/app/series/org-series-contents/video/" + series.courseKey]);
  }
  goToVoice(type: string, series) {
    this.router.navigate([
      "/app/series/org-series-contents/voices/" + type + "/" + series.id,
    ]);
  }
  goToReadableSeries(item: any) {
      window.open(item.fileUrl, "_blank");
      this.log.event(
        AnalyticEvent.internalPagesEvents.customOrgReadItemClicked, '',
        { title: item["title" + this.lang] },
      );
      this.api.post("series/reads/count/" + item.id, {}).subscribe(
        (result: any) => {},
        (error: any) => {
          this.log.error("Error logging link click");
        },
      );
    }
  }